<template>
  <div>
    <b-card no-body>
      <div class="m-2">
        <b-row class="pb-1">
          <b-col cols="12">
            <h4>Danh sách thông báo</h4>
          </b-col>
        </b-row>
        <b-row class="pb-1">
          <b-col class="text-left" cols="5">
            <b-button class="btn-sm mr-50" variant="primary" @click="New()">
              <feather-icon class="align-text-top" icon="PlusIcon" size="16"/>
              Thêm mới
            </b-button>
            <b-button class="btn-sm" variant="primary" @click="DeleteList()">
              <feather-icon class="align-text-top" icon="DeleteIcon" size="16"/>
              Xóa
            </b-button>
          </b-col>
          <b-col cols="6">
            <b-input-group>
              <b-form-input v-model="searchQuery" placeholder="Tìm kiếm " v-on:keydown.enter="quickSearch"/>
              <b-input-group-append is-text role="button" @click="quickSearch">
                <feather-icon icon="SearchIcon"/>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <vue-good-table :columns="options.fields" :isLoading.sync="isLoading" :line-numbers="true" :rows="items"
                            :select-options="{ enabled: true }" :totalRows="totalRecords"
                            mode="remote"
                            @on-page-change="onPageChange" @on-sort-change="onSortChange" @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange" @on-selected-rows-change="selectionChanged">
              <template slot="table-row" slot-scope="props">
                <!-- Column: Action -->
                <span v-if="props.column.field === 'action'">
                    <span>
                      <b-button class="btn-icon" size="sm" variant="primary" @click="Edit(props.row, props.row.id)">
                        <feather-icon icon="Edit2Icon"/>
                      </b-button>
                      <b-button class="btn-icon" size="sm" style="margin-left: 6px" variant="danger"
                                @click="DeleteItem(props.row, props.row.id)">
                        <feather-icon icon="TrashIcon"/>
                      </b-button>
                    </span>
                  </span>
                <span v-else-if="props.column.field === 'effect_date'">
                    <span v-html="props.row.effect_date"></span>
                  </span>
                <span v-else-if="props.column.field === 'contents'">
                    <span v-html="props.row.contents"></span>
                  </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-modal id="modal-edit" :title="getTitle()" size="xl" @ok="handleOk">
      <form ref="form">
        <b-row>
          <b-col cols="7">
            <b-row>
              <b-col cols="12">
                <b-form-group>
                  <label>Loại thông báo <span class='text-danger'>*</span></label>
                  <Select2 v-model="currentItem.type_notice_id" :options="noticesType" :state="validateStateSub('type_notice_id')"
                           required/>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group>
                  <label>Tên thông báo <span class='text-danger'>*</span></label>
                  <b-form-input v-model="currentItem.name" :state="validateState('name')" placeholder="Tên thông báo"
                                required/>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group>
                  <label>Trạng thái <span class='text-danger'>*</span></label>
                  <Select2 v-model="currentItem.status" :options="statusList" :state="validateState('status')"/>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <label>Thời gian hiển thị<span class='text-danger'>*</span>:</label>
              </b-col>
            </b-row>
            <b-row>
              <b-col v-for="(oDate, stt) in dateList" :key="stt" cols="12">
                <b-row>
                  <b-col cols="6">
                    <b-form-group>
                      <label>Từ ngày:</label>
                      <b-row>
                        <b-col cols="7">
                          <b-form-datepicker v-model="oDate.effect_day" :min="minDate" dateFormat='dd/mm/yyyy'
                                             locale="vi"></b-form-datepicker>
                        </b-col>
                        <b-col cols="5">
                          <b-form-timepicker
                              v-model="oDate.effect_time"
                              locale="en"
                              placeholder="HH:mm:SS">
                          </b-form-timepicker>
                        </b-col>
                      </b-row>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group>
                      <label>Đến ngày:</label>
                      <b-row>
                        <b-col cols="7">
                          <b-form-datepicker v-model="oDate.end_effect_day"
                                             :min="oDate.effect_day?oDate.effect_day:minDate" dateFormat='dd/mm/yyyy'
                                             locale="vi"></b-form-datepicker>
                        </b-col>
                        <b-col cols="5">
                          <b-form-timepicker
                              v-model="oDate.end_effect_time"
                              locale="en"
                              placeholder="HH:mm:SS">
                          </b-form-timepicker>
                          <div v-if="stt>0" class="btn-remove" @click="removeItem(stt)">
                            <svg fill="none" height="30" viewBox="0 0 30 30" width="30"
                                 xmlns="http://www.w3.org/2000/svg">
                              <path
                                  d="M12.8329 5.17243V5.67243H13.3329H17.4996C17.5824 5.67243 17.6654 5.70631 17.7294 5.77243C17.7938 5.83913 17.8329 5.9331 17.8329 6.03449C17.8329 6.13589 17.7938 6.22986 17.7294 6.29656C17.6654 6.36268 17.5824 6.39656 17.4996 6.39656H16.6663H16.1663V6.89656V16.3793C16.1663 16.938 15.9516 17.4705 15.5745 17.8605C15.1981 18.25 14.6911 18.4655 14.1663 18.4655H5.83293C5.30807 18.4655 4.80113 18.25 4.42465 17.8605C4.04762 17.4705 3.83293 16.938 3.83293 16.3793V6.89656V6.39656H3.33293H2.49959C2.41676 6.39656 2.33375 6.36268 2.26983 6.29656C2.20535 6.22986 2.16626 6.13589 2.16626 6.03449C2.16626 5.9331 2.20535 5.83913 2.26983 5.77243C2.33375 5.70631 2.41676 5.67243 2.49959 5.67243H6.66626H7.16626V5.17243V3.74221C7.1833 3.3204 7.36023 2.92588 7.65366 2.64297C7.94842 2.35878 8.33647 2.21003 8.73215 2.22385L8.74087 2.22415H8.74959H11.2496H11.2583L11.267 2.22385C11.6627 2.21003 12.0508 2.35878 12.3455 2.64297C12.639 2.92588 12.8159 3.32039 12.8329 3.7422V5.17243ZM11.6663 5.67243H12.1663V5.17243V3.73277C12.1663 3.45113 11.9964 3.24649 11.843 3.13467C11.6783 3.01473 11.4697 2.94829 11.2496 2.94829H8.74959C8.52953 2.94829 8.32087 3.01473 8.15622 3.13467C8.00274 3.24649 7.83293 3.45113 7.83293 3.73277V5.17243V5.67243H8.33293H11.6663ZM4.99959 6.39656H4.49959V6.89656V16.3793C4.49959 16.7352 4.63609 17.0798 4.88418 17.3364C5.13282 17.5936 5.47373 17.7414 5.83293 17.7414H14.1663C14.5255 17.7414 14.8664 17.5936 15.115 17.3364C15.3631 17.0798 15.4996 16.7352 15.4996 16.3793V6.89656V6.39656H14.9996H4.99959Z"
                                  fill="#FF5A5A" stroke="#FF5A5A"></path>
                              <path
                                  d="M7.72935 14.0552C7.66543 14.1213 7.58242 14.1552 7.49959 14.1552C7.41676 14.1552 7.33375 14.1213 7.26983 14.0552C7.20535 13.9885 7.16626 13.8945 7.16626 13.7931V10.3448C7.16626 10.2434 7.20535 10.1495 7.26983 10.0828C7.33375 10.0166 7.41676 9.98276 7.49959 9.98276C7.58242 9.98276 7.66543 10.0166 7.72935 10.0828C7.79383 10.1495 7.83293 10.2434 7.83293 10.3448V13.7931C7.83293 13.8945 7.79383 13.9885 7.72935 14.0552Z"
                                  fill="#FF5A5A" stroke="#FF5A5A"></path>
                              <path
                                  d="M12.7294 14.0552C12.6654 14.1213 12.5824 14.1552 12.4996 14.1552C12.4168 14.1552 12.3338 14.1213 12.2698 14.0552C12.2054 13.9885 12.1663 13.8945 12.1663 13.7931V10.3448C12.1663 10.2434 12.2054 10.1495 12.2698 10.0828C12.3338 10.0166 12.4168 9.98276 12.4996 9.98276C12.5824 9.98276 12.6654 10.0166 12.7294 10.0828C12.7938 10.1495 12.8329 10.2434 12.8329 10.3448V13.7931C12.8329 13.8945 12.7938 13.9885 12.7294 14.0552Z"
                                  fill="#FF5A5A" stroke="#FF5A5A"></path>
                            </svg>
                          </div>
                        </b-col>
                      </b-row>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12">
                <b-button class="btn-sm mr-50" variant="primary" @click="newDate()">
                  <feather-icon class="align-text-top" icon="PlusIcon" size="16"/>
                  Thêm
                </b-button>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="5">
            <b-col cols="12">
              <b-form-group>
                <label>Nội dung thông báo<span class='text-danger'>*</span></label>
                <DxHtmlEditor v-model="currentItem.contents" :value="currentItem.contents" height="500px">
                  <DxMediaResizing :enabled="true"/>
                  <DxImageUpload :tabs="['file']" file-upload-mode="base64"/>
                  <DxTableResizing :enabled="true"/>
                  <DxTableContextMenu :enabled="true"/>
                  <DxToolbar :multiline="true">
                    <DxItem name="undo"/>
                    <DxItem name="redo"/>
                    <DxItem name="separator"/>
                    <DxItem :accepted-values="sizeValues" name="size"/>
                    <DxItem :accepted-values="fontValues" name="font"/>
                    <DxItem name="separator"/>
                    <DxItem name="bold"/>
                    <DxItem name="italic"/>
                    <DxItem name="strike"/>
                    <DxItem name="underline"/>
                    <DxItem name="separator"/>
                    <DxItem name="alignLeft"/>
                    <DxItem name="alignCenter"/>
                    <DxItem name="alignRight"/>
                    <DxItem name="alignJustify"/>
                    <DxItem name="separator"/>
                    <DxItem name="orderedList"/>
                    <DxItem name="bulletList"/>
                    <DxItem name="separator"/>
                    <DxItem :accepted-values="headerValues" name="header"/>
                    <DxItem name="separator"/>
                    <DxItem name="color"/>
                    <DxItem name="background"/>
                    <DxItem name="separator"/>
                    <DxItem name="link"/>
                    <DxItem name="image"/>
                    <DxItem name="separator"/>
                    <DxItem name="clear"/>
                    <DxItem name="codeBlock"/>
                    <DxItem name="blockquote"/>
                    <DxItem name="separator"/>
                    <DxItem name="insertTable"/>
                    <DxItem name="deleteTable"/>
                    <DxItem name="insertRowAbove"/>
                    <DxItem name="insertRowBelow"/>
                    <DxItem name="deleteRow"/>
                    <DxItem name="insertColumnLeft"/>
                    <DxItem name="insertColumnRight"/>
                    <DxItem name="deleteColumn"/>
                  </DxToolbar>
                </DxHtmlEditor>
              </b-form-group>
            </b-col>
          </b-col>
        </b-row>
      </form>
    </b-modal>
  </div>
</template>
<script>

import {ValidationProvider, ValidationObserver} from "vee-validate";
import vSelect from "vue-select";
import {VueGoodTable} from "vue-good-table";
import {
  BFormDatepicker,
  BFormTimepicker,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BModal,
  BFormCheckbox,
  BFormGroup,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend
} from "bootstrap-vue";

import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "@core/scss/vue/libs/vue-good-table.scss";
import Select2 from "v-select2-component";
import moment from "moment";
import {getuserName} from '@/@core/utils/utils';

import {
  DxHtmlEditor,
  DxTableContextMenu,
  DxTableResizing,
  DxMediaResizing,
  DxImageUpload,
  DxToolbar,
  DxItem
} from 'devextreme-vue/html-editor';

export default {
  name: "adminTopic",
  components: {
    BFormDatepicker,
    BFormTimepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BFormTextarea,
    BInputGroup, BInputGroupAppend,
    DxHtmlEditor,
    DxTableContextMenu,
    DxTableResizing,
    DxMediaResizing,
    DxImageUpload,
    DxToolbar,
    DxItem
  },
  methods: {
    validateState(pro) {
      if (!this.isSubmit) return null;
      if (!this.currentItem[pro]) return false;
      else return true;
      return null;
    },
    validateStateSub(pro) {
      if (!this.isSubmit) return null;
      if (!this.currentItemSub[pro]) return false;
      else return true;
      return null;
    },
    getTitle() {
      if (this.editMode) {
        return "Cập nhật thông báo ";
      } else {
        return "Thêm mới thông báo ";
      }
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },
    onPerPageChange(params) {
      this.updateParams({pageSize: params.currentPerPage});
      this.loadItems();
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.serverParams.page = 1;
      this.updateParams(params);
      console.log(this.serverParams);
      this.loadItems();
    },

    New() {
      this.currentItem = {};
      this.editMode = false;
      this.modal_title = "Thêm mới thông báo ";
      this.$bvModal.show("modal-edit");
    },

    async Edit(item) {
      this.loading(true);
      this.modal_title = "Cập nhật thông báo";
      this.currentItem = item;
      useJwt
          .get("portal/notices/" + item.id)
          .then((response) => {
            this.loading(false);
            this.currentItem = response.data.result.master;
            this.dateList = response.data.result.listEffect;
            this.extDateList();
            this.isLoading = false;
          });
      this.editMode = true;
      this.$bvModal.show("modal-edit");
    },

    async DeleteItem(item, index, button) {
      this.currentItem = item;
      const url = `portal/notices/${item.id}`;
      let resModal = await this.$bvModal.msgBoxConfirm(
          "Vui lòng xác nhận bạn muốn xoá thông báo",
          {title: "Please Confirm", size: "sm"}
      );
      if (resModal) {
        try {
          this.loading(true);
          let res = await useJwt.delete(url);
          this.loading(false);
          if (res.data.code == 200) {
            this.loadItems();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Xoá thông báo thành công!",
                icon: "CheckSquareIcon",
                variant: "success",
              },
            });
          }
        } catch (error) {
          this.loading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi xoá thông báo",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      }
    },
    selectionChanged(params) {
      this.rowSelection = params.selectedRows;
    },
    async DeleteList() {
      if (this.rowSelection.length == 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Bạn phải chọn dữ liệu cần xóa. Xin vui lòng kiểm tra lại!",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return;
      }
      let resModal = await this.$bvModal.msgBoxConfirm(
          "Vui lòng xác nhận bạn muốn xoá thông báo",
          {title: "Please Confirm", size: "sm"}
      );

      if (resModal) {
        const listId = [];
        for (var i = 0; i < this.rowSelection.length; i++) {
          listId.push(this.rowSelection[i].id);
        }
        const createParams = {
          ids: listId.join(',')
        };
        try {
          this.loading(true);
          const res = await useJwt.post("portal/deletenotices", createParams);
          this.loading(false);
          if (res.data.code == 200) {
            this.isSubmit = false;
            this.loadItems();
            return this.$toast({
              component: ToastificationContent,
              props: {
                title: "Xóa thông báo thành công!",
                icon: "CheckSquareIcon",
                variant: "success",
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: res.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        } catch (error) {
          this.loading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi xóa thông báo ",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      }
    },
    async extDateList() {
      this.dateList.forEach(function (item) {
        if (item.effect_date) {
          var arrStart = item.effect_date.split('T');
          item.effect_day = arrStart[0];
          item.effect_time = arrStart[1] ? arrStart[1] : '01:00:00';
        }
        if (item.end_effect_date) {
          var arrEnd = item.end_effect_date.split('T');
          item.end_effect_day = arrEnd[0];
          item.end_effect_time = arrEnd[1] ? arrEnd[1] : '01:00:00';
        }
      });
    },
    async customDateList() {
      this.currentItem.effect_date = '';
      var self = this;
      this.dateList.forEach(function (item) {
        var startDate = new Date(item.effect_day);
        var arrTime = item.effect_time.split(':');
        var endDate = new Date(item.end_effect_day);
        var arrEndTime = item.end_effect_time.split(':');
        item.effect_date = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), arrTime[0], arrTime[1], arrTime[2]);
        item.end_effect_date = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), arrEndTime[0], arrEndTime[1], arrEndTime[2]);
        if (self.currentItem.effect_date) {
          self.currentItem.effect_date = self.currentItem.effect_date + '<br>' + item.effect_time + ' ' + startDate.getDate() + '/' + (startDate.getMonth() + 1) + '/' + startDate.getFullYear() + ' - ' + item.end_effect_time + ' ' + endDate.getDate() + '/' + (endDate.getMonth() + 1) + '/' + endDate.getFullYear();
        } else {
          self.currentItem.effect_date = item.effect_time + ' ' + startDate.getDate() + '/' + (startDate.getMonth() + 1) + '/' + startDate.getFullYear() + ' - ' + item.end_effect_time + ' ' + endDate.getDate() + '/' + (endDate.getMonth() + 1) + '/' + endDate.getFullYear();
        }
//chuyển về múi giờ 0h (vì khi parse json => tự động -timezon utc7)
        item.effect_date.setMinutes(item.effect_date.getMinutes() - item.effect_date.getTimezoneOffset());
        item.end_effect_date.setMinutes(item.end_effect_date.getMinutes() - item.end_effect_date.getTimezoneOffset());
      });
    },
    async handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      const userName = getuserName();
      this.customDateList();
      // this.isSubmit = true;
      const bIsValid = await this.isValid(this.currentItem);
      if (!bIsValid) {
        return;
      }

      const bIsValidDate = await this.validDateEffect();
      if (!bIsValidDate) {
        return;
      }

      if (this.editMode) {
        const url = `portal/notices/${this.currentItem.id}`;
        const updateParams = {
          id: this.currentItem.id,
          name: this.currentItem.name,
          status: this.currentItem.status,
          type_notice_id: this.currentItem.type_notice_id,
          contents: this.currentItem.contents,
          created_at: userName,
          updated_at: userName,
          effect_date: this.currentItem.effect_date,
          listEffect: JSON.stringify(this.dateList)
        };
        try {
          this.loading(true);
          const res = await useJwt.put(url, updateParams);
          this.loading(false);
          if (res.data.code == 200) {
            // this.isSubmit = false;
            this.loadItems();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Cập nhật thành công!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
            this.$bvModal.hide("modal-edit");
            return;
          }
        } catch (error) {
          this.loading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi cập nhật thông báo ",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return
        }
      }
      try {
        const createParams = {
          id: 0,
          name: this.currentItem.name,
          status: this.currentItem.status,
          type_notice_id: this.currentItem.type_notice_id,
          contents: this.currentItem.contents,
          updated_at: userName,
          created_at: userName,
          effect_date: this.currentItem.effect_date,
          listEffect: JSON.stringify(this.dateList)
        };
        this.loading(true);
        const res = await useJwt.post("portal/notices", createParams);
        this.loading(false);
        if (res.data.code == 200) {
          // this.isSubmit = false;
          this.loadItems();
          this.$bvModal.hide("modal-edit");
          return this.$toast({
            component: ToastificationContent,
            props: {
              title: "Thêm mới thông báo thành công!",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        }
      } catch (error) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi thêm mới thông báo ",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    /**
     *
     * @param {*} item
     */
    async isValid(item) {
      if (!item.name) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Tên không được để trống",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      } else if (!item.type_notice_id || item.type_notice_id < 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Loại thông báo không được để trống.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      } else if (item.status == null || item.status === '' || item.status == undefined) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Trạng thái không được để trống.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      } else if (item.contents == null || item.contents === '' || item.contents == undefined) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Nội dung không được để trống.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      } else if (this.dateList.length == 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Thời gian áp dụng không được để trống.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      }
      return true;
    },
    async validDateEffect() {
      if (this.dateList.length == 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Thời gian áp dụng không được để trống.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      }
//nếu k phải trạng thái có hiệu lực thì k quan tâm tới ngày giờ hiệu lực
      if (this.currentItem.status !== 1) {
        return true;
      }
      for (let i = 0; i < this.dateList.length; i++) {
        let objOrigin = this.dateList[i];
        if (!objOrigin.effect_date || !objOrigin.end_effect_date) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Bạn phải chọn thời gian hiển thị dòng thứ: " + (i + 1) + ">",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });

          return false;
        } else if (objOrigin.effect_date >= objOrigin.end_effect_date) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Thời gian hiển thị từ ngày không được lớn hơn đến ngày. <dòng thứ: " + (i + 1) + ">",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return false;
        } else if (objOrigin.effect_date <= new Date()) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Thời gian bắt đầu hiển thị không được nhỏ hơn thời gian hiện tại. <dòng thứ: " + (i + 1) + ">",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return false;
        }
        for (let j = i + 1; j < this.dateList.length; j++) {
          let objSource = this.dateList[j];
          if ((objOrigin.effect_date >= objSource.effect_date && objOrigin.effect_date <= objSource.end_effect_date)
              || (objOrigin.end_effect_date >= objSource.effect_date && objOrigin.end_effect_date <= objSource.end_effect_date)
              || (objOrigin.effect_date <= objSource.effect_date && objOrigin.end_effect_date >= objSource.end_effect_date)) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Thời gian hiển thị tại dòng thứ: " + (i + 1) + " trùng với dòng thứ " + (j + 1) + " >",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });

            return false;
          }
        }
      }

      return true;
    },

    async loadItems() {
      try {
        this.loading(true);
        this.serverParams.columnFilters.searchQuery = this.searchQuery;
        useJwt.post("portal/notices/getAll", this.serverParams).then((response) => {
          var result = response.data;
          if (result.code == 200) {
            this.items = result.result;
            this.totalRecords = result.totalRecords;
          }
          this.isLoading = false;
          this.loading(false);
        });
      } catch {
        this.loading(false);
      }
    },

    async quickSearch() {
      this.loadItems();
    },

    dateFormat(v) {
      return moment(v, 'YYYYMMDDHHmmss').format('DD/MM/YYYY hh:mm:ss')
    },
    /**
     *
     */
    loadNoticesType() {
      try {
        this.loading(true);
        useJwt
            .get("portal/typeNotice", {
              columnFilters: {},
            })
            .then((response) => {
              this.loading(false);
              this.noticesType = [];
              response.data.result.forEach(item => {
                this.noticesType.push({'id': item.id, 'text': item.name});
              });
              this.totalRecords = response.data.totalRecords;
              this.isLoading = false;
            });
      } catch {
        this.loading(false);
      }
    },
    removeItem(idx) {
      this.dateList.splice(idx, 1);
    },
    newDate() {
      this.dateList.push({
        effect_day: new Date(),
        end_effect_day: new Date(),
        effect_time: '01:00:00',
        end_effect_time: '01:00:00'
      });
    }
  },

  mounted() {
    this.loadItems();
    this.isSubmit = false;
    this.loadNoticesType();
  },

  data() {
    return {
      isLoading: false,
      isSubmit: false,
      totalRecords: 0,
      items: [],
      dateList: [{}],
      statusList: [
        {id: 1, text: "Hiệu lực"},
        {id: 0, text: "Hết hiệu lực"},
        {id: 2, text: "Chưa có hiệu lực"}
      ],
      editMode: false,
      totalItem: 0,
      searchQuery: "",
      currentItem: {},
      noticesType: [],
      rowSelection: [],
      minDate: new Date(),
      options: {
        fields: [
          {field: "action", label: "Cài đặt", width: "120px"},
          {
            field: "type_notice_name",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Loại thông báo",
            required: true,
            disabled: true,
          },
          {
            field: "name",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Tiêu đề thông báo",
            required: true,
            disabled: true,
          },
          {
            field: "contents",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Nội dung thông báo",
            required: true,
            disabled: true,
          },
          {
            field: "effect_date",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Thời gian hiển thị",
            disabled: true
          },
          {
            field: "status_name",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Trạng thái",
            required: true,
            disabled: true,
          }
        ]
      },
      serverParams: {
        "columnFilters": {},
        "sort": [
          {"field": "created_date", "type": "desc"}
        ],
        "page": 1,
        "pageSize": 20,
        "lang": 1
      },
      sizeValues: ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'],
      fontValues: ['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana'],
      headerValues: [false, 1, 2, 3, 4, 5]
    };
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
.readonly {
  pointer-events: none;
  touch-action: none;

  .select2-selection {
    background: #eee;
    box-shadow: none;
  }

  .select2-selection__arrow,
  .select2-selection__clear {
    display: none;
  }
}

.btn-remove {
  text-align: center;
  cursor: pointer;
  margin-top: 8px;
  position: absolute;
  right: -25px;
  top: 0;
}

table.vgt-table td {
  min-width: 100px;
}
</style>
